function enumToOptions (enoom) {
  return Object.entries(enoom)
    .map(([label, value])=> {
      return {label, value};
    });
}

export default enumToOptions;
